import Repository from '@/repositories/repository'

const PrimeRepository = {
  async getPrime(queryParams: any = {}) {
    const params = {
      ...queryParams
    }

    return await Repository('prime', 'page', params)
  }
}

export default PrimeRepository
